/**
 * get and parse a value from local storage using it's key
 * @param appKey: the local storage key you would like to get the value of
 * @param valueObjKey: optionally provide a specific key to get if the local storage value is an object
 */
export const getLocalStorageItem = (appKey: string, valueObjKey = '') => {
  const data = window.localStorage.getItem(appKey);
  if (!data) {
    return null;
  }
  try {
    const dataObj = JSON.parse(data);
    if (!valueObjKey) {
      return dataObj;
    }
    return dataObj[valueObjKey];
  } catch (e) {
    return data;
  }
};

/**
 * stringify and set a new value to local storage, or update an existing one
 * @param appKey: the local storage key you would like to set/update the value of
 * @param value: the value to set/update the key to
 */
export const setLocalStorageItem = (appKey: string, value: any) => {
  window.localStorage.setItem(appKey, JSON.stringify(value));
};
